/**
 * User form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import RequiredMark from 'Common/Form/RequiredMark';
import { FormattedMessage } from 'react-intl';

import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import { childrenType } from 'Types';

export default class ReactQuillInput extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        children: childrenType,
        input: PropTypes.any.isRequired,
        label: PropTypes.string,
        meta: PropTypes.object.isRequired,
        className: PropTypes.string,
        rowClassName: PropTypes.string,
        withLabel: PropTypes.bool,
        maxLength: PropTypes.number,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        quillProps: PropTypes.object,
        onBlurSkip: PropTypes.bool,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        withLabel: false,
        onBlurSkip: false,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    render() {
        const {
            input,
            label,
            meta: { touched, error, form },
            withLabel,
            disabled,
            required,
            quillProps,
            onBlurSkip
        } = this.props;

        let id = `${form}-${input.name}-field`,
            message = error,
            placeholders = {};

        if (Array.isArray(message)) {
            [message, placeholders] = message;
        }

        let errorMessage = /validation.error.\w+/.test(message)
            ? this.context.intl.formatMessage({ id: message }, placeholders)
            : message;

        return (
            <FormControl disabled={disabled} error={error && touched}>
                {withLabel && (
                    <InputLabel htmlFor={id}>
                        <FormattedMessage id={`field.${label}.label`} />
                        {required ? <RequiredMark /> : ''}
                    </InputLabel>
                )}
                <ReactQuill
                    {...input}
                    onChange={(newValue, delta, source) => {
                        if (source === 'user') {
                            input.onChange(newValue);
                        }
                    }}
                    onBlur={(range, source, quill) => {
                        if (!onBlurSkip)
                            input.onBlur(quill.getHTML());
                    }}
                    {...quillProps}
                />

                {touched && error && <FormHelperText className="errors-list">{errorMessage}</FormHelperText>}
            </FormControl>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/Form/ReactQuillInput.jsx